<template>
  <v-container 
  fluid
  carousel
  text-xs-center
  :class="{'smallBg': $vuetify.breakpoint.smAndDown, 'largeBg': $vuetify.breakpoint.mdAndUp}"
  :style="{'background-image': 'url(' + require('assets/img/parallax/aerial2.jpg') + ')'}">
    <div logos column wrap align-center justify-center>
      <div>
        <div ref="ts4" class="logo-svg">
          <Logo4/>
        </div>
        <div ref="ts3" class="logo-svg">
          <Logo3/>
        </div>          
        <div ref="ts2" class="logo-svg">
          <Logo2/>
        </div>          
        <div ref="ts1" class="logo-svg">
          <Logo1/>
        </div>
      </div>
    </div>
    <div info-box column wrap align-center justify-center>
      <!-- <v-flex> -->
        <div class="info-box">
          <p>We are spatial information specialists</p>
        </div>
      <!-- </v-flex> -->
    </div>
    <div column wrap align-center justify-center>
      <v-flex>
        <div class="typed white--text">
          <a href="" class="typewrite white--text" data-period="5000" data-type='["Civil Surveying", "Asset Capture &amp; Inspection",  "UAV Mapping", "Laser Scanning", "Spatial Software" ]'>
            <span class="wrap"></span>
          </a>
        </div> 
      </v-flex>
    </div>    
  </v-container>
</template>

<script>
import Logo1 from 'assets/svg/ts1.svg';
import Logo2 from 'assets/svg/ts2.svg';
import Logo3 from 'assets/svg/ts3.svg';
import Logo4 from 'assets/svg/ts4.svg';
import TxtType from 'assets/utils/TxtType.js'
import { TweenLite } from 'gsap';
export default {
  mounted() { 
    TweenLite.from(this.$refs.ts1, 5, { y: -500 })
    TweenLite.from(this.$refs.ts2, 5, { x: -1000 })
    TweenLite.from(this.$refs.ts3, 5, { x: 1000 })
    TweenLite.to(this.$refs.ts2, 5, {rotation:360})
    TweenLite.to(this.$refs.ts3, 5, {rotation:-360})

    setTimeout(() => {
      let elements = document.getElementsByClassName('typewrite');
      for (let i=0; i<elements.length; i++) {
          let toRotate = elements[i].getAttribute('data-type');
          let period = elements[i].getAttribute('data-period');
          if (toRotate) {
            new TxtType(elements[i], JSON.parse(toRotate), period);
          }
      }
      // INJECT CSS
      var css = document.createElement("style");
      css.type = "text/css";
      css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
      document.body.appendChild(css);
    }, 8000);
  },  
  components: {
    Logo1,
    Logo2,
    Logo3,
    Logo4
  },
  data () {
    return {
      image: 'assets/img/parallax/aerial2.jpg'
    }
  }
}
</script>

<style>
  .carousel{
    height:100%;
  }

  .logos{
    margin-top: 100px;
  }

  .logo-svg {
    width: 100%;
    margin: 0 auto;
    left: 0px;
    position: absolute;
  }

  .hero-text {
    color: white; 
    text-shadow: black 0.1em 0.1em 0.2em
  }

  .info-box {
    margin: 0 auto;
    max-width: 350px;
    margin-top: 100px;
    z-index: 1000;
    background-color: #f1592a;
    padding: 10px;
  }

  .info-box p {
    color: #fff;
    z-index: 2;
    margin: 10px 0;
    box-sizing: border-box;
  }

  .typed{
    vertical-align: bottom !important;
  }

  .typed a:hover {
    cursor:pointer;
  }

  .typewrite{
    font-family: monospace;
    color: white;
    text-shadow: black 0.1em 0.1em 0.2em
  }
  .smallBg {
    background-size: 889px 500px;
    background-position-x: 50%;
  }

  .largeBg {
    background-position: center top;
  }

</style>